// extracted by mini-css-extract-plugin
var _1 = "Rny9A";
export { _1 as "base" }
